module.exports = __webpack_public_path__ + "aafe9fb0ce5b3e9c297e2c8e17a79c7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/list/subImg/sir-wyyc.png
// module id = 1159
// module chunks = 0